var logger = (function () {

    let showLogs = getCookie('showLogs') === '1';
    let ret = console;

    if (!showLogs) {
        let empty = {};
        for (let funcName in console) {
            empty[funcName] = () => { };
        }
        ret = empty;
    }

    return ret;
})();

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export default logger;